/* tslint:disable */
/* eslint-disable */
/* @relayHash 306f679f0ab032ffcfa824aeb65fc31e */

import { ConcreteRequest } from "relay-runtime";
export type FavoriteAction = "ADD" | "REMOVE" | "%future added value";
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type FavoritePageInput = {
    page: string;
    name?: string | null;
    query?: string | null;
    type: string;
    userId: string;
    favoriteId?: string | null;
    action: FavoriteAction;
    clientMutationId?: string | null;
};
export type SharedSaveSearchMutationVariables = {
    searchTypes?: Array<types | null> | null;
    searchPages?: Array<string | null> | null;
    input: FavoritePageInput;
};
export type SharedSaveSearchMutationResponse = {
    readonly favoritePage: {
        readonly user: {
            readonly savedSearches: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly serviceId: string | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type SharedSaveSearchMutation = {
    readonly response: SharedSaveSearchMutationResponse;
    readonly variables: SharedSaveSearchMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "searchTypes",
    "type": "[types]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "searchPages",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "FavoritePageInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "pages",
    "variableName": "searchPages"
  },
  {
    "kind": "Variable",
    "name": "types",
    "variableName": "searchTypes"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SharedSaveSearchMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "favoritePage",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FavoritePagePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "savedSearches",
                "name": "favorites",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "favoritesConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "favoritesEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Favorite",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SharedSaveSearchMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "favoritePage",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FavoritePagePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "savedSearches",
                "name": "favorites",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "favoritesConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "favoritesEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Favorite",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "SharedSaveSearchMutation",
    "id": "app-buyer-finding/293.0.0-2020-12-09T21:42:09.926Z/SharedSaveSearchMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'fd6c2ea58beea8f1cd1e94cf5495da93';
export default node;
